import { Component, Inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ENV_CONFIG } from 'src/app/core/injection.token';
import { DEFAULT_USERNAME, DICTIONARY_REQUEST_TYPES } from 'src/app/extensions/constants/commonConstants';
import { uriNormalize } from 'src/app/extensions/utilities';

@Component({
  selector: 'profile-general-view',
  templateUrl: './profile-general-view.component.html',
  styleUrls: ['./profile-general-view.component.scss'],
  standalone: false,
})
export class ProfileGeneralViewComponent implements OnInit {
  @Input() profileData: app.models.ProfileModel = {
    username: DEFAULT_USERNAME,
    partner: {},
  } as app.models.ProfileModel;
  @Input() readOnly: boolean = true;
  @Input() requestTypes: app.models.DictionaryRequestType[];

  allowClientDataRequest: boolean = false;

  constructor(
    @Inject(ENV_CONFIG) private _envConfig: env.EnvData,
    private _router: Router
  ) {}

  ngOnInit(): void {
    this.allowClientDataRequest = this.requestTypes?.some(
      rt => rt.dictionaryRequestTypeCode === DICTIONARY_REQUEST_TYPES.CLIENT_DATA
    );
  }

  redirectClientDataRequestHandler() {
    this._router.navigate(['requests/client-data']);
  }

  navigateToChangePasswordHandler() {
    window.location.href = `${uriNormalize(this._envConfig.ISSUER)}/TapAccount/ChangePassword?returnOriginUrl=${uriNormalize(encodeURIComponent(this._envConfig.REDIRECT_URI))}`;
  }
}
